export default __webpack_public_path__ + "static/media/terock-overlay.b990f614.png";